import React from 'react';
import { CreateRenewalForm } from '@/components/forms/CreateRenewalForm';
import { PoliciesSelectProvider } from '@/context/policiesContext';

export const CreateRenewalPage = () => {
	return (
		<PoliciesSelectProvider>
			<CreateRenewalForm />
		</PoliciesSelectProvider>
	);
};
